// N-17: `reason` on an escalation is workflow-configured free text (INV-CONFIG --
// it is tenant data, never a fixed enum a frontend table could translate), but it
// still reaches the UI as a raw machine identifier when a workflow sets it that way
// (e.g. "consultation_submitted"). This does not invent a business meaning for it:
// it only stops showing the underscore-joined identifier verbatim, splitting it
// into words. Prose a tenant already wrote in their own words passes through
// untouched. Shared by EscalationContextPanel and EscalationQueue so the same
// reason reads the same way everywhere it appears.
export function humanizeEscalationReason(reason: string): string {
  if (/^[a-z0-9]+(_[a-z0-9]+)+$/i.test(reason.trim())) {
    const words = reason.trim().split('_');
    return words[0].charAt(0).toUpperCase() + words[0].slice(1) + ' ' + words.slice(1).join(' ');
  }
  return reason;
}
